import { useAuth } from "../context/AuthContext";

export default function GpsManagementTabs({ activeView, onViewChange }) {
  const { user } = useAuth() || {};
  const role = String(user?.role || "").trim().toLowerCase().replace(/[ -]+/g, "_");
  const sections = ["technical_admin", "admin"].includes(role)
    ? [["fleet", "Live fleet"], ["trips", "Trips & activity"], ["replay", "Route replay"], ["devices", "Devices"], ["assignments", "Assignments"]]
    : [["fleet", "Live fleet"], ["trips", "Trips & activity"], ["replay", "Route replay"]];
  return (
    <nav className="gps-management-tabs" aria-label="Live tracking sections">
      {sections.map(([value, label]) => (
        <button key={value} type="button" className={activeView === value ? "is-active" : ""}
          aria-current={activeView === value ? "page" : undefined} onClick={() => onViewChange(value)}>
          {label}
        </button>
      ))}
    </nav>
  );
}
